// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluatePublicationFinderPage-cls1_wwu","cls2":"EvaluatePublicationFinderPage-cls2_TCe EvaluatePublicationFinderPage-cls1_wwu"};